import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// 为angular ssr模式提供的dom

@Injectable({
    providedIn: 'root'
})
export class SsrPolyfillService {
    constructor(@Inject(DOCUMENT) private _doc: Document) { }

    getWindow(): Window | null {
        return this._doc.defaultView;
    }

    getDocument(): HTMLElement | null {
        return this._doc.documentElement;
    }

    getLocation(): Location {
        return this._doc.location;
    }

    createElement(tag: string): HTMLElement {
        return this._doc.createElement(tag);
    }
}
